"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const starknet_1 = require("starknet");
const types_1 = require("./types");
const signer_1 = require("./signer");
class DeviceAccount extends starknet_1.Account {
    constructor(provider, address, keychain, modal) {
        super(provider, address, new signer_1.Signer(keychain, modal));
        this.address = address;
        this.keychain = keychain;
        this.modal = modal;
    }
    /**
     * Estimate Fee for a method on starknet
     *
     * @param calls the invocation object containing:
     * - contractAddress - the address of the contract
     * - entrypoint - the entrypoint of the contract
     * - calldata - (defaults to []) the calldata
     * - signature - (defaults to []) the signature
     *
     * @returns response from addTransaction
     */
    estimateInvokeFee(calls, details) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.keychain.estimateInvokeFee(calls, Object.assign(Object.assign({}, details), { chainId: this.chainId }));
        });
    }
    estimateDeclareFee(payload, details) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.keychain.estimateDeclareFee(payload, Object.assign(Object.assign({}, details), { chainId: this.chainId }));
        });
    }
    /**
     * Invoke execute function in account contract
     *
     * @param calls the invocation object or an array of them, containing:
     * - contractAddress - the address of the contract
     * - entrypoint - the entrypoint of the contract
     * - calldata - (defaults to []) the calldata
     * - signature - (defaults to []) the signature
     * @param abis (optional) the abi of the contract for better displaying
     *
     * @returns response from addTransaction
     */
    execute(calls, abis, transactionsDetail) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!transactionsDetail) {
                transactionsDetail = {};
            }
            try {
                const res = yield this.keychain.execute(calls, abis, transactionsDetail);
                if (res.code === types_1.ResponseCodes.SUCCESS) {
                    return res;
                }
                this.modal.open();
                const res2 = yield this.keychain.execute(calls, abis, transactionsDetail, true);
                this.modal.close();
                if (res2.code !== types_1.ResponseCodes.SUCCESS) {
                    throw new Error(res2.message);
                }
                return res2;
            }
            catch (e) {
                console.error(e);
                throw e;
            }
        });
    }
    /**
     * Sign an JSON object for off-chain usage with the starknet private key and return the signature
     * This adds a message prefix so it cant be interchanged with transactions
     *
     * @param json - JSON object to be signed
     * @returns the signature of the JSON object
     * @throws {Error} if the JSON object is not a valid JSON
     */
    signMessage(typedData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.modal.open();
                const res = yield this.keychain.signMessage(typedData, this.address);
                this.modal.close();
                return res;
            }
            catch (e) {
                console.error(e);
                throw e;
            }
        });
    }
}
exports.default = DeviceAccount;
//# sourceMappingURL=device.js.map